import DialogYesNo from './DialogYesNo';
export default DialogYesNo;
export { default as DialogYesNo } from './DialogYesNo';